import { render, staticRenderFns } from "./pricing-card.vue?vue&type=template&id=d6c3c600&"
import script from "./pricing-card.vue?vue&type=script&lang=js&"
export * from "./pricing-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports